<template>
    <section class="login_gradient login_100">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="flex-adjust">
                        <div class="login-box">
                            <div class="login-logo-wrap text-center">
                                <a href="/">
                                    <img src="/img/logo.png" />
                                </a>
                                <small>Admin Panel, Reset Password</small>
                            </div>
                            <div class="box-white">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <form method="POST" @submit.prevent="forget">

                                            <template v-if="commonErrors && commonErrors.email">
                                                <p class="alert alert-danger"  v-for="item in commonErrors.email">{{item}}</p>
                                            </template>
                                            <template v-if="commonErrors && commonErrors.password">
                                                <p class="alert alert-danger"  v-for="item in commonErrors.password">{{item}}</p>
                                            </template>

                                            <template v-if="errorMessage">
                                                <p class="alert alert-danger">{{errorMessage}}</p>
                                            </template>

                                            <template v-if="successMessage">
                                                <p class="alert alert-success">{{successMessage}}</p>
                                            </template>

                                            <div class="form-group login_input">
                                                <input id="email" type="text" class="input_text" v-model="form.email" name="email" value="" required>
                                                <label for="input" class="control-label">Email</label>

                                            </div>
                                            <div class="form-group login_input">
                                                <input id="password" type="password" class="input_text" v-model="form.password" name="password" required>
                                                <label for="input" class="control-label">Password</label>

                                            </div>
                                            <div class="form-group login_input">
                                                <input id="password-confirm" type="password" v-model="form.password_confirmation" class="input_text" name="password_confirmation" required>
                                                <label for="input" class="control-label">Confirm Password</label>
                                            </div>
                                            <input type="submit" class="btn btn-primary login" value="Reset Password">

                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>


import { mapState, mapActions, mapGetters  } from 'vuex';
import axios from "axios";

export default {
    name: "ResetPassword",
    created(){
        this.setLoginLoading(true);
        this.setCommonErrors([]);
        this.setErrorMessage(null);
        this.setSuccessMessage(null);
    },
    data() {
        return {
            submitted: false,
            form: {
                email: null,
                password: null,
                password_confirmation: null,
                token:this.$route.params.id
            }
        }
    },
    methods: {
        ...mapActions([
            'setAuth',
            'setLoginLoading',
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage'
        ]),
        forget() {
            let self = this;
            this.setLoginLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            this.setSuccessMessage(null);
            return axios
                .post('api/auth/confirmPassword', this.form, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                .then(({ data }) => {

                    console.log(data.token);
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        console.log(data);
                        self.setSuccessMessage(data.data);
                        // localStorage.setItem('auth', JSON.stringify(data.token));
                        // self.setAuth(data.token);
                        // self.$router.push({ name: 'dashboard' });
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoginLoading(false);

                });
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage'
        ])
    }
}
</script>

<style scoped>

</style>
